export default __webpack_public_path__ + "static/media/search.769bc303.svg";